// Copyright (c) 2025 Deere & Company

import File from '@deere/cps-it.warranty-model-factory/lib/file';
import t from 'tcomb';

const FileList = t.list(File, 'file');

export const getDefaultState = () => new FileList([]);

export default FileList;



// WEBPACK FOOTER //
// ./src/rga/rga-search-results/state/files-list.js